<template>
<div>
  <v-app-bar color="blue accent-1" >
      <v-app-bar-nav-icon color="white" @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">Hana's English</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn outlined small>Login</v-btn> -->
  </v-app-bar>
    <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    >
      <sideBar @setSubCategory="setSubCategory"/>
    </v-navigation-drawer>
  <v-container>
    
    <v-card class="pa-2">
      <v-card-title>
        {{category_title}}
      </v-card-title>
      <v-card-text>
        <v-divider/>
        <v-list>
          <div v-for="post in post_list" :key="post.id">
            <v-list-item @click="setPost(post)">
              <v-list-item-content class="text-left">
                <v-list-item-title>
                  <v-list-item-subtitle  v-show="!$vuetify.breakpoint.mdAndUp">
                    {{ formatDate(post.created_at) }}
                  </v-list-item-subtitle>
                  {{ post.title }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-show="$vuetify.breakpoint.mdAndUp">
                  <v-list-item-subtitle>
                   {{ formatDate(post.created_at) }}
                  </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
            <v-divider/>
          </div> 
          </v-list>
      </v-card-text>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="10"
          circle
        ></v-pagination>
      </div>
    </v-card>
    <v-dialog v-model="show_post_view" max-width="800px">
      <v-card outlined class="pa-1">
        <postView :set_post="set_post"/>
        <v-card-actions>
          <v-btn block outlined  @click="show_post_view=!show_post_view">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>   
  </v-container>
</div>
</template>

<script>
  import postView  from '@/components/postView.vue'
  import sideBar from '@/components/sideBar.vue'
  import axios from 'axios'

  export default {
    data: () => ({
      drawer: false,
      show_post_view: false,
      page: 1,

      category_title: 'Total',
      sub_category : {},
      sub_category_id : 0,
      
      post_list:[],
      set_post : {},
    }),
  
    watch:{
      'sub_category_id': function(newSubCategory, oldSubCategory) {
        this.setPsotList()
      },
      'page': function(newPage, oldPage){
        this.setPsotList()
      }
    },

    components: {
      postView,
      sideBar,
    },

    mounted(){
      this.setPsotList()
      if(this.$route.params.postParams){
        const setPost = this.$route.params.postParams
        console.log(setPost)
        this.setPost(setPost)
      }
    },
    methods:{
      setSubCategory(sub_category){
        this.drawer = false
        this.sub_category = sub_category
        this.sub_category_id = sub_category.id
        this.category_title = sub_category.name
      },

      setPsotList(){
        const subCategory_id = this.sub_category.id
        if(subCategory_id==null){
          this.getTotalPost()
        } else {
          this.getSubCategoryPost()
        }
      },

      setPost(post){
        this.set_post = post
        this.show_post_view = true
      },

      getTotalPost(){
        axios
        .get(`api/post/get-posts/?page=${this.page}`)
        .then(res=>{
          console.log(res.data)
          this.post_list = res.data.results
        })
        .catch(err=>{
          console.log('post가 더 없습니다.')
        })
      },

      getSubCategoryPost(){
        const subCategory_id = this.sub_category_id
          axios
          .get(`api/post/posts-by-sub-category/${subCategory_id}/?page=${this.page}`)
          .then(res=>{
            this.post_list = res.data.results
          })
          .catch(err=>{
            console.log('post가 더 없습니다.')
          })
      },
      formatDate(dateTimeString) {
          if(dateTimeString==null){
          } else {
              const dateTime = new Date(dateTimeString);
              // const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              const options = { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              return dateTime.toLocaleString(undefined, options);
          }
	      },  
      },
      computed:{
        formattedDateTimes() {
          return this.dateTimeStrings.map((dateTimeString) => this.formatDate(dateTimeString));
          },
      }
  }
</script>
